(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hero-veddel"] && !Shopify.designMode) return;
  try {
    
  class HeroVeddel {
    constructor(root) {
      this.root = root;
      this.slides = Array.from(root.querySelectorAll('[data-hero-slide]'));
      this.dots = Array.from(root.querySelectorAll('[data-hero-dot]'));
      this.current = 0;
      this.timer = null;
      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.autoplay = root.dataset.autoplay === 'true' && !this.reducedMotion;
      this.autoplayMs = parseInt(root.dataset.autoplayMs, 10) || 6000;

      if (this.slides.length <= 1) {
        return;
      }

      this.bind();
      this.start();
    }

    bind() {
      const prev = this.root.querySelector('[data-hero-prev]');
      const next = this.root.querySelector('[data-hero-next]');

      if (prev) prev.addEventListener('click', () => { this.go(this.current - 1); this.restart(); });
      if (next) next.addEventListener('click', () => { this.go(this.current + 1); this.restart(); });

      this.dots.forEach((dot) => {
        dot.addEventListener('click', () => {
          this.go(parseInt(dot.dataset.heroDot, 10));
          this.restart();
        });
      });

      this.root.addEventListener('mouseenter', () => this.stop());
      this.root.addEventListener('mouseleave', () => this.start());
      this.root.addEventListener('focusin', () => this.stop());
      this.root.addEventListener('focusout', () => this.start());
    }

    go(index) {
      const total = this.slides.length;
      const target = ((index % total) + total) % total;

      this.slides.forEach((slide, i) => {
        const active = i === target;
        slide.classList.toggle('is-active', active);
        slide.setAttribute('aria-hidden', active ? 'false' : 'true');
      });

      this.dots.forEach((dot, i) => {
        dot.classList.toggle('is-active', i === target);
      });

      this.current = target;
    }

    start() {
      if (!this.autoplay || this.timer) return;
      this.timer = window.setInterval(() => this.go(this.current + 1), this.autoplayMs);
    }

    stop() {
      if (this.timer) {
        window.clearInterval(this.timer);
        this.timer = null;
      }
    }

    restart() {
      this.stop();
      this.start();
    }
  }

  function initHeroVeddel() {
    document.querySelectorAll('[data-hero-veddel]').forEach((root) => {
      if (root.dataset.heroInit === 'true') return;
      root.dataset.heroInit = 'true';
      new HeroVeddel(root);
    });
  }

  if (document.readyState !== 'loading') {
    initHeroVeddel();
  } else {
    document.addEventListener('DOMContentLoaded', initHeroVeddel);
  }

  document.addEventListener('shopify:section:load', initHeroVeddel);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
